export const QUICK_LINK_LIST = {
  en: [
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Coaching',
      breadcrumb: 'Coaching Events',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
  ],
  es: [
    {
      route: 'drivers',
      featureName: 'Agregar conductor',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Capacitación',
      breadcrumb: 'Eventos de Capacitación',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de seguridad de la flota',
    },
  ],
  fr: [
    {
      route: 'drivers',
      featureName: 'Ajouter un pilote',
      breadcrumb: 'Pilotes / Ajouter un pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Encadrement',
      breadcrumb: "Événements d'entraînement",
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
  ],
  pt: [
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Drivers / Adicionar driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Treinamento',
      breadcrumb: 'Eventos de coaching',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de Segurança da Frota',
      breadcrumb: 'Relatórios / Relatório de Segurança da Frota',
    },
  ],
  'pt-BR': [
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Motoristas  / Adicionar motorista',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Treinamento',
      breadcrumb: 'Eventos de treinamento',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de segurança da frota',
      breadcrumb: 'Relatórios / Relatório de segurança da frota',
    },
  ],
  'fr-CA': [
    {
      route: 'drivers',
      featureName: 'Pilote',
      breadcrumb: 'Pilotes / Ajouter Un Conducteur',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'coaching',
      breadcrumb: 'Conducteurs Entraînables',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
  ],
  'en-GB': [
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Coaching',
      breadcrumb: 'Coaching Events',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
  ],
  'es-419': [
    {
      route: 'drivers',
      featureName: 'Agregar controlador',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'coaching',
      breadcrumb: 'Eventos de Coaching',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de Seguridad de la Flota',
    },
  ],
};

export const SEARCH_AUTOCOMPLETE_LIST = {
  en: [
    // home
    {
      route: 'home',
      featureName: 'Fleet Highlights',
      breadcrumb: 'Home / Fleet Highlights',
    },
    {
      route: 'home',
      featureName: 'Top Drivers',
      breadcrumb: 'Home / Top Drivers',
    },
    {
      route: 'home',
      featureName: 'Require Coaching Drivers',
      breadcrumb: 'Home / Require Coaching Drivers',
    },
    {
      route: 'home',
      featureName: 'Event Summary',
      breadcrumb: 'Home / Event Summary',
    },
    {
      route: 'home',
      featureName: 'Event Trend',
      breadcrumb: 'Home / Event Trend',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Trip List',
      breadcrumb: 'Trips / Overview / Trip List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Active Drivers',
      breadcrumb: 'Trips / Overview / Active Drivers',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Highlights',
      breadcrumb: 'Drivers / Overview / Driver Highlights',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coach Driver',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Assign Tags',
      breadcrumb: 'Drivers / Overview / Assign Tags',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Coaching Panel',
      breadcrumb: 'Drivers / Overview / Coaching Panel',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Panic Button',
      breadcrumb: 'Drivers / Overview / Panic Button',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Summary',
      breadcrumb: 'Drivers / Overview / Event Summary',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Trend',
      breadcrumb: 'Drivers / Overview / Event Trend',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver List',
      breadcrumb: 'Drivers / Manage Drivers / Driver List',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provision Driver',
      breadcrumb: 'Drivers / Manage Drivers / Provision Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coaching Session',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Completed Sessions',
      breadcrumb: 'Drivers / Overview / Completed Sessions',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Live Asset Tracking',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'View Live Stream',
      breadcrumb: 'Live View / View Live Stream',
    },
    // report
    {
      route: 'reports',
      featureName: 'Reports',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
    {
      route: 'reports',
      featureName: 'Export History',
      breadcrumb: 'Reports / Export history',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Coaching Effectiveness Report (Driver)',
      breadcrumb: 'Reports / Coaching Effectiveness Report (Driver)',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Asset List',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Driver Assignment',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Modify Asset Duty Type',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Format Device SD Card',
      breadcrumb: 'Assets / Overview / Asset List ',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Reboot Device',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Batch Asset Update',
      breadcrumb: 'Assets / Manage / Batch Updation',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Semi-Provisioned Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Basic Configurations',
      breadcrumb: 'Configurations / Basic / Basic Configurations',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Custom Events',
      breadcrumb: 'Configurations / Basic / Custom Events',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Advanced Configurations',
      breadcrumb: 'Configurations / Advanced / Advanced Configurations',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Thresholds',
      breadcrumb: 'Configurations / Coaching / Coaching Thresholds',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Tagging',
      breadcrumb: 'Configurations / Tagging',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Attributes',
      breadcrumb: 'Configurations / Tagging / Attributes',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Add Attributes',
      breadcrumb: 'Configurations / Tagging / Add Attribute',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Tags',
      breadcrumb: 'Configurations / Tagging / Tags',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Add Tags',
      breadcrumb: 'Configurations / Tagging / Add Tags',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entities',
      breadcrumb: 'Configurations / Tagging / Entities',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Challenged Events',
      breadcrumb: 'Challenges / Challenged Events',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Coaching Panel',
      breadcrumb: 'Coaching / Coaching Panel',
    },
    {
      route: 'coaching',
      featureName: 'Coachable Drivers',
      breadcrumb: 'Coaching / Coachable Drivers',
    },
    {
      route: 'coaching',
      featureName: 'Completed Coaching Sessions',
      breadcrumb: 'Coaching / Completed Coaching Sessions',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Events',
      breadcrumb: 'Safety Events / Events View',
    },
    {
      route: 'safety-events',
      featureName: 'Safety Events',
      breadcrumb: 'Safety Events / Events View',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Video Request',
      breadcrumb: 'Video Request',
    },
    {
      route: 'video-requests',
      featureName: 'Video Requests List',
      breadcrumb: 'Video Requests List',
    },
    {
      route: 'video-requests',
      featureName: 'Panic Button List',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Event On-Demand List',
      breadcrumb: 'Event On-Demand List',
    },
    {
      route: 'video-requests',
      featureName: 'Create Video Requests',
      breadcrumb: 'Create Video Request',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Users',
      breadcrumb: 'Users',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management/edit-user',
      featureName: 'Add Users',
      breadcrumb: 'Users / Add User',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management/edit-role',
      featureName: 'ADD Roles',
      breadcrumb: 'Roles / Add Role',
      queryParams: {
        action: 'add',
      },
    },
  ],
  es: [
    // home
    {
      route: 'home',
      featureName: 'Aspectos destacados de la flota',
      breadcrumb: 'Inicio / Lo más destacado de la flota',
    },
    {
      route: 'home',
      featureName: 'Conductores mejores',
      breadcrumb: 'Inicio / Principales conductores',
    },
    {
      route: 'home',
      featureName: 'Requiere entrenadoras',
      breadcrumb: 'Inicio / Requiere entrenadoras',
    },
    {
      route: 'home',
      featureName: 'Resumen de eventos',
      breadcrumb: 'Inicio / Resumen del eventos',
    },
    {
      route: 'home',
      featureName: 'Tendencia de eventoss',
      breadcrumb: 'Inicio / Tendencia de eventoss',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viajes',
      breadcrumb: 'Viajes / Descripción general / Lista de viajes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conductores activos',
      breadcrumb: 'Viajes / Descripción general / Conductores activos',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Agregar conductor',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Aspectos destacados del conductor',
      breadcrumb: 'Controladores / Descripción general / Aspectos destacados del controlador',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Panel de entrenamiento de conductores',
      breadcrumb: 'Controladores / Descripción general / Panel de entrenamiento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Botón de pánico del conductor',
      breadcrumb: 'Controladores / Descripción general / Botón de pánico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumen del evento del conductor',
      breadcrumb: 'Controladores / Descripción general / Resumen de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendencia de eventos del conductor',
      breadcrumb: 'Impulsores / Descripción general / Tendencia de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de conductores',
      breadcrumb: 'Controladores / Administrar controladores / Lista de controladores',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Conductora de provisión',
      breadcrumb: 'Controladores / Administrar controladores / Aprovisionar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sesión de coaching',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sesiones finalizadas',
      breadcrumb: 'Conductores / Visión general / Sesiones finalizadas',
      queryParams: {
        tab: 'overview',
      },
    },

    {
      route: 'drivers',
      featureName: 'Conductor de autocar',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Etiquetas de asignación de conductores',
      breadcrumb: 'Controladores / Visión general / Asignar etiquetas',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Seguimiento de activos en vivo',
      breadcrumb: 'Vista en vivo / Seguimiento de activos en vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmisión en vivo',
      breadcrumb: 'Vista en vivo / Ver transmisión en vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Informes',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de seguridad de la flota',
    },
    {
      route: 'reports',
      featureName: 'Historial de exportaciones',
      breadcrumb: 'Informes / Exportación-Historia',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Informe sobre la eficacia del entrenamiento (Conductor)',
      breadcrumb: 'Informes / Informe sobre la eficacia del entrenamiento (Conductor)',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de activos',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Asignación de conductor',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Modificar tipo de derecho de activo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Formatear la tarjeta SD del dispositivo',
      breadcrumb: 'Activos / Lista de activos ',
    },
    {
      route: 'assets',
      featureName: 'Reiniciar dispositivo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semiprovisionados',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configuraciones básicas',
      breadcrumb: 'Configuraciones / Básica / Configuraciones Básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configuraciones / Básica / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configuraciones avanzadas',
      breadcrumb: 'Configuraciones / Avanzadas / Configuraciones Avanzadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Umbrales de entrenamiento',
      breadcrumb: 'Configuraciones / Coaching / Umbrales de entrenamiento',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configuración de Coaching',
      breadcrumb: 'Configuraciones / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Etiquetado',
      breadcrumb: 'Configuraciones / Etiquetado',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Atributos',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Añadir atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Añadir etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir etiquetas',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configuraciones / Etiquetado / Entidades',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Eventos cuestionados',
      breadcrumb: 'Cuestionados / Eventos cuestionados',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Panel de entrenamiento',
      breadcrumb: 'Panel de Entrenamiento / Coaching',
    },
    {
      route: 'coaching',
      featureName: 'Conductores entrenables',
      breadcrumb: 'Coaching / Conductores entrenables',
    },
    {
      route: 'coaching',
      featureName: 'Sesiones de coaching completadas',
      breadcrumb: 'Coaching / Sesiones de coaching completadas',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de seguridad',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Solicitudes de vídeo',
      breadcrumb: 'Solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de solicitudes de vídeo',
      breadcrumb: 'Lista de solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de botones de pánico',
      breadcrumb: 'Lista de botones de pánico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos a la carta',
      breadcrumb: 'Lista de eventos a la carta',
    },
    {
      route: 'video-requests',
      featureName: 'Crear solicitud de vídeo',
      breadcrumb: 'Crear solicitud de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'USUARIOS',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR USUARIO',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR ROL',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
    },
  ],
  fr: [
    // home
    {
      route: 'home',
      featureName: 'Faits saillants de la flotte',
      breadcrumb: 'Accueil / Faits saillants de la flotte',
    },
    {
      route: 'home',
      featureName: 'Meilleurs chauffeurss',
      breadcrumb: 'Accueil / Meilleurs pilotes',
    },
    {
      route: 'home',
      featureName: 'Exiger des chauffeurs entraîneurs',
      breadcrumb: 'Accueil / Exiger des chauffeurs entraîneurs',
    },
    {
      route: 'home',
      featureName: 'Résumé des Événements',
      breadcrumb: "Accueil / Résumé de l'Événement",
    },
    {
      route: 'home',
      featureName: 'Tendance des Événements',
      breadcrumb: 'Accueil / Tendance des Événements',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Liste de voyage',
      breadcrumb: 'Trajets / Aperçu / Liste des trajets',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conducteurs actifs',
      breadcrumb: 'Trajets / Aperçu / Conducteurs actifs',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Ajouter un pilote',
      breadcrumb: 'Pilotes / Ajouter un pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Faits saillants du chauffeur',
      breadcrumb: 'Pilotes / Aperçu / Faits saillants des pilotes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Panneau d'encadrement des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Panel de coaching',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Bouton panique du conducteur',
      breadcrumb: 'Pilotes / Aperçu / Bouton panique',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Résumé de l'événement du conducteur",
      breadcrumb: "Pilotes / Présentation / Résumé de l'événement",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendance des événements de conduite',
      breadcrumb: 'Pilotes / Aperçu / Tendance des événements',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Liste des pilotes',
      breadcrumb: 'Pilotes / Gérer les pilotes / Liste des pilotes',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provisionner le pilote',
      breadcrumb: 'Pilotes / Gérer les pilotes / Provisionner le pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Session de coaching',
      breadcrumb: "'Chauffeurs / Aperçu / Chauffeur d'autocar'",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessions terminées',
      breadcrumb: 'Chauffeurs / Aperçu / Sessions terminées',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Chauffeur d'autocar",
      breadcrumb: "Chauffeurs / Aperçu / Chauffeur d'autocar",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Tags sur l'attribution des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Attribuer des étiquettes',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Suivi des actifs en direct',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'Voir la diffusion en direct',
      breadcrumb: 'Affichage en direct/suivi des actifs en direct',
    },
    // report
    {
      route: 'reports',
      featureName: 'Rapports',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
    {
      route: 'reports',
      featureName: 'Historique des exportations',
      breadcrumb: 'Rapports / Histoire des exportations',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: "Rapport sur l'efficacité de l'entraînement (conducteur)",
      breadcrumb: "Rapports / Rapport sur l'efficacité de l'entraînement (conducteur)",
    },
    // assets
    {
      route: 'assets',
      featureName: 'Liste des actifs',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Affectation du conducteur',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Modifier le type de droit de l'actif",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Formater la carte SD de l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Redémarrer l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Dispositifs',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Appareils semi-provisionnés',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurations de base',
      breadcrumb: 'Configurations / De base / Configurations de base',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Événements personnalisés',
      breadcrumb: 'Configurations / De base / Événements personnalisés',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configurations avancées',
      breadcrumb: 'Configurations / Avancées / Configurations avancées',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Seuils d entraînement',
      breadcrumb: 'Configurations / Coaching / Seuils d entraînement',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Balisage',
      breadcrumb: 'Configurations / balisage',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Attributs',
      breadcrumb: 'Configurations / balisage / attributs',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Ajouter des attributs',
      breadcrumb: 'Configurations / Balisage / Ajouter un attribut',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Balises',
      breadcrumb: 'Configurations / Balisage / Balises',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Ajouter des tags',
      breadcrumb: 'Configurations / Balisage / Ajouter des balises',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entités',
      breadcrumb: 'Configurations / Balisage / Entités',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Événements contestés',
      breadcrumb: 'Défis / Événements contestés',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: "Panneau d'encadrement",
      breadcrumb: "Entraînement / Panel d'entraîneursl",
    },
    {
      route: 'coaching',
      featureName: 'Conducteurs entraînables',
      breadcrumb: 'Coaching / Conducteurs à coacher',
    },
    {
      route: 'coaching',
      featureName: 'Sessions de coaching terminées',
      breadcrumb: 'Coaching / Sessions de coaching terminées',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Événements',
      breadcrumb: 'Événements de sécurité / Vue des Événements',
    },
    {
      route: 'safety-events',
      featureName: 'Événements liés à la sécurité',
      breadcrumb: "Événements de sécurité / Vue d'ensemble des événements",
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Demandes de vidéo',
      breadcrumb: 'Demandes de vidéo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de pedidos de vídeo',
      breadcrumb: 'Lista de pedidos de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des boutons de panique',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des événements à la demande',
      breadcrumb: 'Liste des événements à la demande',
    },
    {
      route: 'video-requests',
      featureName: 'Criar pedido de vídeo',
      breadcrumb: 'Criar pedido de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Utilisateurs',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Ajouter un utilisateur',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Rôles',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management',
      featureName: 'AJOUTER RÔLE ',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
    },
  ],
  pt: [
    // home
    {
      route: 'home',
      featureName: 'Destaques da frota',
      breadcrumb: 'Home / Destaques da Frota',
    },
    {
      route: 'home',
      featureName: 'Principais motoristas',
      breadcrumb: 'Início / Principais motoristas',
    },
    {
      route: 'home',
      featureName: 'Requer treinamento',
      breadcrumb: 'Início / Exigir motoristas de treinamento',
    },
    {
      route: 'home',
      featureName: 'Resumo do evento',
      breadcrumb: 'Início / Resumo do evento',
    },
    {
      route: 'home',
      featureName: 'Tendência de evento',
      breadcrumb: 'Início / Tendência do evento',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viagens',
      breadcrumb: 'Viagens / Visão geral / Lista de viagens',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Drivers ativos',
      breadcrumb: 'Viagens / Visão geral / Motoristas ativos',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Drivers / Adicionar driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Destaques do motorista',
      breadcrumb: 'Drivers / Visão geral / Destaques do driver',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Painel de Orientação de Motoristas',
      breadcrumb: 'Drivers / Visão geral / Painel de treinamento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Botão de pânico do motorista',
      breadcrumb: 'Drivers / Visão geral / Botão de pânico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumo do evento do motorista',
      breadcrumb: 'Drivers / Visão geral / Resumo do Evento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendência de eventos de motorista',
      breadcrumb: 'Drivers / Visão geral / Resumo do evento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de motoristas',
      breadcrumb: 'Drivers / Gerenciar Drivers / Lista de Drivers',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver de provisão',
      breadcrumb: 'Drivers / Gerenciar Drivers / Provisionar Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessão de Coaching',
      breadcrumb: 'Motoristas / Resumo / Motorista de autocarro',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessões concluídas',
      breadcrumb: 'Drivers / Visão geral / Sessões concluídas',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Motorista de autocarro',
      breadcrumb: 'Motoristas / Resumo / Motorista de autocarro',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Etiquetas de atribuição de condutor',
      breadcrumb: 'Condutores / Descrição geral / Atribuir etiquetas',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Rastreamento de ativos ao vivo',
      breadcrumb: 'Visualização ao vivo / Rastreamento de ativos ao vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmissão ao vivo',
      breadcrumb: 'Visualização ao vivo/Visualização de transmissão ao vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Relatórios',
      breadcrumb: 'Relatórios / Todos os Relatórios',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de Segurança da Frota',
      breadcrumb: 'Relatórios / Relatório de Segurança da Frota',
    },
    {
      route: 'reports',
      featureName: 'Histórico de exportação',
      breadcrumb: 'Relatórios / História da exportação',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Relatório de Eficácia do Coaching (Driver)',
      breadcrumb: 'Relatórios / Relatório de Eficácia do Coaching (Driver)',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de ativos',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Atribuição de Motorista',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Modificar tipo de dever de ativo',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Formatar o cartão SD do dispositivo',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Reinicializar dispositivo',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semi-provisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semi-provisionados',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semi-provisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurações Básicas',
      breadcrumb: 'Configurações / Básico / Configurações Básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configurações / Básico / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configurações avançadas',
      breadcrumb: 'Configurações / Configurações Avançadas / Avançadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Limiares de Coaching',
      breadcrumb: 'Configurações / Coaching / Limiares de Coaching',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configuração de treino',
      breadcrumb: 'Configurações / Coaching / Configuração do Coaching',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Marcação',
      breadcrumb: 'Configurações / Marcação',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configurações / Marcação / Atributos',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Adicionar atributos',
      breadcrumb: 'Configurações / Marcação / Adicionar atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configurações / Marcação / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Adicionar etiquetas',
      breadcrumb: 'Configurações / Marcação / Adicionar etiquetas',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configurações / Marcação / Entidades',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Evento Desafiados',
      breadcrumb: 'Desafios / Eventos Desafiados',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Painel de Treino',
      breadcrumb: 'Coaching / Painel de Coaching',
    },
    {
      route: 'coaching',
      featureName: 'Condutores treináveis',
      breadcrumb: 'Coaching / Condutores treináveis',
    },
    {
      route: 'coaching',
      featureName: 'Sessões de Coaching concluídas',
      breadcrumb: 'Coaching / Sessões de Coaching concluídas',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de segurança / Vista de Eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de segurança',
      breadcrumb: 'Eventos de segurança / Eventos Ver',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Pedidos de vídeo',
      breadcrumb: 'Pedidos de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des demandes de vidéos',
      breadcrumb: 'Liste des demandes de vidéos',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de Botões de Pânico',
      breadcrumb: 'Lista de Botões de Pânico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos a pedido',
      breadcrumb: 'Lista de eventos a pedido',
    },
    {
      route: 'video-requests',
      featureName: 'Créer une demande de vidéo',
      breadcrumb: 'Créer une demande de vidéo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Utilizadores',
      breadcrumb: 'Utilizadores',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'ADICIONAR UTILIZADOR',
      breadcrumb: 'Utilizadores',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Funções',
      breadcrumb: 'Funções',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management',
      featureName: 'ADICIONAR ROLE',
      breadcrumb: 'Funções',
      queryParams: {
        tab: 'roles',
      },
    },
  ],
  'pt-BR': [
    // home
    {
      route: 'home',
      featureName: 'Destaques da frota',
      breadcrumb: 'Início  / Destaques da frota',
    },
    {
      route: 'home',
      featureName: 'Principais motoristas',
      breadcrumb: 'Início / Principais motoristas',
    },
    {
      route: 'home',
      featureName: 'Exigir condutores de treinamento',
      breadcrumb: 'Início / Exigir motoristas de treinamento',
    },
    {
      route: 'home',
      featureName: 'Resumo do evento',
      breadcrumb: 'Início / Resumo do evento',
    },
    {
      route: 'home',
      featureName: 'Tendência de eventos',
      breadcrumb: 'Início / Tendência de eventos',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viagens',
      breadcrumb: 'Viagens / Visão geral / Lista de viagens',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Motoristas ativos',
      breadcrumb: 'Viagens / Visão geral / Motorista ativo',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Motoristas / Adicionar motorista',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Destaques do motorista',
      breadcrumb: 'Motoristas / Visão geral / Destaques do motorista',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Motorista de ônibus',
      breadcrumb: 'Motoristas / Visão geral / Motorista de ônibus',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tags de atribuição de motorista',
      breadcrumb: 'Motoristas / Visão geral / Atribuir tags',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Painel de treinamento de motoristas',
      breadcrumb: 'Condutores / Visão geral / Painel de treinamento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Botão de pânico do motorista',
      breadcrumb: 'Motoristas / Visão geral / Botão de pânico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumo do evento do motorista',
      breadcrumb: 'Motoristas / Visão geral / Resumo do evento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendência de eventos do motorista',
      breadcrumb: 'Motoristas / Visão geral / Tendência de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de drivers',
      breadcrumb: 'Motoristas / Gerenciar motoristas / Lista de motoristas',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Motorista de provisão',
      breadcrumb: 'Motoristas / Gerenciar motoristas / Prover motorista',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessão de treinamento',
      breadcrumb: 'Motoristas / Visão geral / Motorista de ônibus',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessões concluídas',
      breadcrumb: 'Motoristas / Visão geral / Sessões concluídas',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Rastreamento de ativos em tempo real',
      breadcrumb: 'Exibição ao vivo/rastreamento de ativos ao vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmissão ao vivo',
      breadcrumb: 'Exibição ao vivo / Exibir transmissão ao vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Relatórios',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de segurança da frota',
      breadcrumb: 'Relatórios / Relatório de segurança da frota',
    },
    {
      route: 'reports',
      featureName: 'Histórico de exportação',
      breadcrumb: 'Relatórios / História da exportação',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Relatório de Eficácia do Coaching (Driver)',
      breadcrumb: 'Relatórios / Relatório de Eficácia do Coaching (Driver)',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de ativos',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Atribuição de motorista',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Modificar o tipo de dever do ativo',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Formatar o cartão SD do dispositivo',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Reinicialização do dispositivo',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Atualização de ativos em lote',
      breadcrumb: 'Ativos / Gerenciar / Atualização de lotes',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Ativos / Dispositivos / Dispositivos semi-provisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semiprovisionados',
      breadcrumb: 'Ativos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurações básicas',
      breadcrumb: 'Configurações / Básico / Configurações básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configurações / Básico / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configurações avançadas',
      breadcrumb: 'Configurações / Avançado / Configurações avançadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Limites de treinamento',
      breadcrumb: 'Configurações / Coaching / Limites de Coaching',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configuração de treinamento',
      breadcrumb: 'Configurações / Coaching / Configuração do Coaching',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Marcação',
      breadcrumb: 'Configurações / Marcação',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configurações / Marcação / Atributos',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Adicionar atributos',
      breadcrumb: 'Configurações / Marcação / Adicionar atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configurações / Marcação / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Adicionar etiquetas',
      breadcrumb: 'Configurações / Marcação / Adicionar tags',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configurações / Marcação / Entidades',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Eventos desafiadores',
      breadcrumb: 'Desafios / Eventos desafiadores',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Painel de treinamento',
      breadcrumb: 'Treinamento / Painel de Treinamento',
    },
    {
      route: 'coaching',
      featureName: 'Motoristas treináveis',
      breadcrumb: 'Condutores treinados / treináveis',
    },
    {
      route: 'coaching',
      featureName: 'Sessões de treinamento concluídas',
      breadcrumb: 'Treinamento / Sessões de treinamento concluídas',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de segurança / Exibição de eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de segurança',
      breadcrumb: 'Eventos de segurança / Visualização de eventos',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Solicitação de vídeo',
      breadcrumb: 'Solicitação de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de solicitações de vídeo',
      breadcrumb: 'Lista de solicitações de vídeot',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de botões de pânico',
      breadcrumb: 'Lista de botões de pânico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos sob demanda',
      breadcrumb: 'Lista de eventos sob demanda',
    },
    {
      route: 'video-requests',
      featureName: 'Criar solicitações de vídeo',
      breadcrumb: 'Criar solicitações de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Users',
      breadcrumb: 'Users',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management/edit-user',
      featureName: 'Adicionar usuários',
      breadcrumb: 'Usuários / Adicionar usuárior',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'user-management',
      featureName: 'Funções',
      breadcrumb: 'Funções',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management/edit-role',
      featureName: 'Funções ADICIONAR',
      breadcrumb: 'Funções / Adicionar função',
      queryParams: {
        action: 'add',
      },
    },
  ],

  'en-GB': [
    // home
    {
      route: 'home',
      featureName: 'Fleet Highlights',
      breadcrumb: 'Home / Fleet Highlights',
    },
    {
      route: 'home',
      featureName: 'Top Drivers',
      breadcrumb: 'Home / Top Drivers',
    },
    {
      route: 'home',
      featureName: 'Require Coaching Drivers',
      breadcrumb: 'Home / Require Coaching Drivers',
    },
    {
      route: 'home',
      featureName: 'Event Summary',
      breadcrumb: 'Home / Event Summary',
    },
    {
      route: 'home',
      featureName: 'Event Trend',
      breadcrumb: 'Home / Event Trend',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Trip List',
      breadcrumb: 'Trips / Overview / Trip List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Active Drivers',
      breadcrumb: 'Trips / Overview / Active Drivers',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Highlights',
      breadcrumb: 'Drivers / Overview / Driver Highlights',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coach Driver',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Assign Tags',
      breadcrumb: 'Drivers / Overview / Assign Tags',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Coaching Panel',
      breadcrumb: 'Drivers / Overview / Coaching Panel',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Panic Button',
      breadcrumb: 'Drivers / Overview / Panic Button',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Summary',
      breadcrumb: 'Drivers / Overview / Event Summary',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Trend',
      breadcrumb: 'Drivers / Overview / Event Trend',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver List',
      breadcrumb: 'Drivers / Manage Drivers / Driver List',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provision Driver',
      breadcrumb: 'Drivers / Manage Drivers / Provision Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coaching Session',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Completed Sessions',
      breadcrumb: 'Drivers / Overview / Completed Sessions',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Live Asset Tracking',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'View Live Stream',
      breadcrumb: 'Live View / View Live Stream',
    },
    // report
    {
      route: 'reports',
      featureName: 'Reports',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
    {
      route: 'reports',
      featureName: 'Export History',
      breadcrumb: 'Reports / Export history',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Coaching Effectiveness Report (Driver)',
      breadcrumb: 'Reports / Coaching Effectiveness Report (Driver)',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Asset List',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Driver Assignment',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Modify Asset Duty Type',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Format Device SD Card',
      breadcrumb: 'Assets / Overview / Asset List ',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Reboot Device',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Batch Asset Update',
      breadcrumb: 'Assets / Manage / Batch Updation',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Semi-Provisioned Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Basic Configurations',
      breadcrumb: 'Configurations / Basic / Basic Configurations',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Custom Events',
      breadcrumb: 'Configurations / Basic / Custom Events',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Advanced Configurations',
      breadcrumb: 'Configurations / Advanced / Advanced Configurations',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Thresholds',
      breadcrumb: 'Configurations / Coaching / Coaching Thresholds',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Tagging',
      breadcrumb: 'Configurations / Tagging',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Attributes',
      breadcrumb: 'Configurations / Tagging / Attributes',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Add Attributes',
      breadcrumb: 'Configurations / Tagging / Add Attribute',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Tags',
      breadcrumb: 'Configurations / Tagging / Tags',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Add Tags',
      breadcrumb: 'Configurations / Tagging / Add Tags',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entities',
      breadcrumb: 'Configurations / Tagging / Entities',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Challenged Events',
      breadcrumb: 'Challenges / Challenged Events',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Coaching Panel',
      breadcrumb: 'Coaching / Coaching Panel',
    },
    {
      route: 'coaching',
      featureName: 'Coachable Drivers',
      breadcrumb: 'Coaching / Coachable Drivers',
    },
    {
      route: 'coaching',
      featureName: 'Completed Coaching Sessions',
      breadcrumb: 'Coaching / Completed Coaching Sessions',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Events',
      breadcrumb: 'Safety Events / Events View',
    },
    {
      route: 'safety-events',
      featureName: 'Safety Events',
      breadcrumb: 'Safety Events / Events View',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Video Request',
      breadcrumb: 'Video Request',
    },
    {
      route: 'video-requests',
      featureName: 'Video Requests List',
      breadcrumb: 'Video Requests List',
    },
    {
      route: 'video-requests',
      featureName: 'Panic Button List',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Event On-Demand List',
      breadcrumb: 'Event On-Demand List',
    },
    {
      route: 'video-requests',
      featureName: 'Create Video Requests',
      breadcrumb: 'Create Video Request',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Users',
      breadcrumb: 'Users',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management/edit-user',
      featureName: 'Add Users',
      breadcrumb: 'Users / Add User',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management/edit-role',
      featureName: 'ADD Roles',
      breadcrumb: 'Roles / Add Role',
      queryParams: {
        action: 'add',
      },
    },
  ],
  'fr-CA': [
    // home
    {
      route: 'home',
      featureName: 'Faits saillants de la flotte',
      breadcrumb: 'Accueil / Faits saillants de la flotte',
    },
    {
      route: 'home',
      featureName: 'Meilleurs chauffeurss',
      breadcrumb: 'Accueil / Meilleurs pilotes',
    },
    {
      route: 'home',
      featureName: 'Exiger des chauffeurs entraîneurs',
      breadcrumb: 'Accueil / Exiger des chauffeurs entraîneurs',
    },
    {
      route: 'home',
      featureName: 'Résumé des Événements',
      breadcrumb: "Accueil / Résumé de l'Événement",
    },
    {
      route: 'home',
      featureName: 'Tendance des Événements',
      breadcrumb: 'Accueil / Tendance des Événements',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Liste de voyage',
      breadcrumb: 'Trajets / Aperçu / Liste des trajets',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conducteurs actifs',
      breadcrumb: 'Trajets / Aperçu / Conducteurs actifs',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Ajouter un pilote',
      breadcrumb: 'Pilotes / Ajouter un pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Faits saillants du chauffeur',
      breadcrumb: 'Pilotes / Aperçu / Faits saillants des pilotes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Panneau d'encadrement des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Panel de coaching',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Bouton panique du conducteur',
      breadcrumb: 'Pilotes / Aperçu / Bouton panique',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Résumé de l'événement du conducteur",
      breadcrumb: "Pilotes / Présentation / Résumé de l'événement",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendance des événements de conduite',
      breadcrumb: 'Pilotes / Aperçu / Tendance des événements',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Liste des pilotes',
      breadcrumb: 'Pilotes / Gérer les pilotes / Liste des pilotes',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provisionner le pilote',
      breadcrumb: 'Pilotes / Gérer les pilotes / Provisionner le pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Session de coaching',
      breadcrumb: "'Chauffeurs / Aperçu / Chauffeur d'autocar'",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessions terminées',
      breadcrumb: 'Chauffeurs / Aperçu / Sessions terminées',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Chauffeur d'autocar",
      breadcrumb: "Chauffeurs / Aperçu / Chauffeur d'autocar",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Tags sur l'attribution des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Attribuer des étiquettes',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Suivi des actifs en direct',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'Voir la diffusion en direct',
      breadcrumb: 'Affichage en direct/suivi des actifs en direct',
    },
    // report
    {
      route: 'reports',
      featureName: 'Rapports',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
    {
      route: 'reports',
      featureName: 'Historique des exportations',
      breadcrumb: 'Rapports / Historique des exportations',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Rapport sur l’efficacité du coaching (pilote)',
      breadcrumb: 'Rapports / Rapport sur l’efficacité du coaching (pilote)',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Liste des actifs',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Affectation du conducteur',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Modifier le type de droit de l'actif",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Formater la carte SD de l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Redémarrer l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Dispositifs',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Appareils semi-provisionnés',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurations de base',
      breadcrumb: 'Configurations / De base / Configurations de base',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Événements personnalisés',
      breadcrumb: 'Configurations / De base / Événements personnalisés',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configurations avancées',
      breadcrumb: 'Configurations / Avancées / Configurations avancées',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Seuils d entraînement',
      breadcrumb: 'Configurations / Coaching / Seuils d entraînement',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Balisage',
      breadcrumb: 'Configurations / balisage',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Attributs',
      breadcrumb: 'Configurations / balisage / attributs',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Ajouter des attributs',
      breadcrumb: 'Configurations / Balisage / Ajouter un attribut',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Balises',
      breadcrumb: 'Configurations / Balisage / Balises',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Ajouter des tags',
      breadcrumb: 'Configurations / Balisage / Ajouter des balises',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entités',
      breadcrumb: 'Configurations / Balisage / Entités',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Événements contestés',
      breadcrumb: 'Défis / Événements contestés',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: "Panneau d'encadrement",
      breadcrumb: "Entraînement / Panel d'entraîneursl",
    },
    {
      route: 'coaching',
      featureName: 'Conducteurs entraînables',
      breadcrumb: 'Coaching / Conducteurs à coacher',
    },
    {
      route: 'coaching',
      featureName: 'Sessions de coaching terminées',
      breadcrumb: 'Coaching / Sessions de coaching terminées',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Événements',
      breadcrumb: 'Événements de sécurité / Vue des Événements',
    },
    {
      route: 'safety-events',
      featureName: 'Événements liés à la sécurité',
      breadcrumb: "Événements de sécurité / Vue d'ensemble des événements",
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Demandes de vidéo',
      breadcrumb: 'Demandes de vidéo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de pedidos de vídeo',
      breadcrumb: 'Lista de pedidos de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des boutons de panique',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des événements à la demande',
      breadcrumb: 'Liste des événements à la demande',
    },
    {
      route: 'video-requests',
      featureName: 'Criar pedido de vídeo',
      breadcrumb: 'Criar pedido de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Utilisateurs',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Ajouter un utilisateur',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Rôles',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management',
      featureName: 'AJOUTER RÔLE ',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
    },
  ],
  'es-419': [
    // home
    {
      route: 'home',
      featureName: 'Aspectos destacados de la flota',
      breadcrumb: 'Inicio / Lo más destacado de la flota',
    },
    {
      route: 'home',
      featureName: 'Conductores mejores',
      breadcrumb: 'Inicio / Principales conductores',
    },
    {
      route: 'home',
      featureName: 'Requiere entrenadoras',
      breadcrumb: 'Inicio / Requiere entrenadoras',
    },
    {
      route: 'home',
      featureName: 'Resumen de eventos',
      breadcrumb: 'Inicio / Resumen del eventos',
    },
    {
      route: 'home',
      featureName: 'Tendencia de eventoss',
      breadcrumb: 'Inicio / Tendencia de eventoss',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viajes',
      breadcrumb: 'Viajes / Descripción general / Lista de viajes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conductores activos',
      breadcrumb: 'Viajes / Descripción general / Conductores activos',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Agregar conductor',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Aspectos destacados del conductor',
      breadcrumb: 'Controladores / Descripción general / Aspectos destacados del controlador',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Panel de entrenamiento de conductores',
      breadcrumb: 'Controladores / Descripción general / Panel de entrenamiento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Botón de pánico del conductor',
      breadcrumb: 'Controladores / Descripción general / Botón de pánico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumen del evento del conductor',
      breadcrumb: 'Controladores / Descripción general / Resumen de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendencia de eventos del conductor',
      breadcrumb: 'Impulsores / Descripción general / Tendencia de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de conductores',
      breadcrumb: 'Controladores / Administrar controladores / Lista de controladores',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Conductora de provisión',
      breadcrumb: 'Controladores / Administrar controladores / Aprovisionar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sesión de coaching',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sesiones finalizadas',
      breadcrumb: 'Conductores / Visión general / Sesiones finalizadas',
      queryParams: {
        tab: 'overview',
      },
    },

    {
      route: 'drivers',
      featureName: 'Conductor de autocar',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Etiquetas de asignación de conductores',
      breadcrumb: 'Controladores / Visión general / Asignar etiquetas',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Seguimiento de activos en vivo',
      breadcrumb: 'Vista en vivo / Seguimiento de activos en vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmisión en vivo',
      breadcrumb: 'Vista en vivo / Ver transmisión en vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Informes',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de seguridad de la flota',
    },
    {
      route: 'reports',
      featureName: 'Informes archivados',
      breadcrumb: 'Informes / Informes archivados',
      queryParams: {
        tab: 'archive',
      },
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de activos',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Asignación de conductor',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Modificar tipo de derecho de activo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Formatear la tarjeta SD del dispositivo',
      breadcrumb: 'Activos / Lista de activos ',
    },
    {
      route: 'assets',
      featureName: 'Reiniciar dispositivo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semiprovisionados',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configuraciones básicas',
      breadcrumb: 'Configuraciones / Básica / Configuraciones Básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configuraciones / Básica / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configuraciones avanzadas',
      breadcrumb: 'Configuraciones / Avanzadas / Configuraciones Avanzadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Umbrales de entrenamiento',
      breadcrumb: 'Configuraciones / Coaching / Umbrales de entrenamiento',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configuración de Coaching',
      breadcrumb: 'Configuraciones / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'Etiquetado',
      breadcrumb: 'Configuraciones / Etiquetado',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Atributos',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Añadir atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Añadir etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir etiquetas',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configuraciones / Etiquetado / Entidades',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Eventos cuestionados',
      breadcrumb: 'Cuestionados / Eventos cuestionados',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Panel de entrenamiento',
      breadcrumb: 'Panel de Entrenamiento / Coaching',
    },
    {
      route: 'coaching',
      featureName: 'Conductores entrenables',
      breadcrumb: 'Coaching / Conductores entrenables',
    },
    {
      route: 'coaching',
      featureName: 'Sesiones de coaching completadas',
      breadcrumb: 'Coaching / Sesiones de coaching completadas',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de seguridad',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Solicitudes de vídeo',
      breadcrumb: 'Solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de solicitudes de vídeo',
      breadcrumb: 'Lista de solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de botones de pánico',
      breadcrumb: 'Lista de botones de pánico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos a la carta',
      breadcrumb: 'Lista de eventos a la carta',
    },
    {
      route: 'video-requests',
      featureName: 'Crear solicitud de vídeo',
      breadcrumb: 'Crear solicitud de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'USUARIOS',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR USUARIO',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR ROL',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
    },
  ],
};
